module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel panel-warning",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-body-vue"
  }, [_c('ul', {
    staticClass: "carBrandContainer"
  }, _vm._l((_vm.ItemsDetails), function(itemsDetail) {
    return _c('li', [_c('div', [_c('router-link', {
      attrs: {
        "to": '/view/0/brand/' + itemsDetail.id,
        "tag": "a"
      }
    }, [_c('span', [_vm._v(_vm._s(itemsDetail.name) + " "), _c('span', [_vm._v("(" + _vm._s(itemsDetail.count) + ")")])])])], 1)])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Marcas")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5f294822", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f294822"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SideMenu/CarBrandSideBar.vue
// module id = 118
// module chunks = 0